<rwidget-alert></rwidget-alert>
<section class="main-grid !block bg-white md:!grid">
    <div>
        <!-- MOBILE -->
        <div class="grid w-full grid-cols-[4rem_1fr_4rem] bg-white pb-3 pt-3 md:hidden">
            <ion-button
                class="pn-light:text-primary pn-app-light:text-primary text-xs normal-case text-secondary dark:text-contrast-yellow"
                [attr.aria-label]="'LOCAL_BTN_BACK' | translate"
                (click)="navigateByViewMode()"
                fill="clear"
                size="small">
                <ion-icon
                    class="mr-1 text-base dark:filter-yellow"
                    title="{{ 'LOCAL_BTN_BACK' | translate }}"
                    src="{{ assetsPath$ | async }}/img/cards/icon-left-arrow.svg"
                    >{{ 'LOCAL_BTN_BACK' | translate }}</ion-icon
                >
            </ion-button>
            <div class="flex items-center justify-center">
                <h1 class="text-base font-bold">
                    {{ (mode === 'add' ? 'ADD_NEW_CARD' : 'EDIT_TRAVEL_CARD_SIDE_TITLE') | translate }}
                </h1>
            </div>
        </div>

        <!-- DESKTOP -->
        <div class="hidden md:flex md:flex-col">
            <h1 class="text-[2.75rem] leading-[3rem]">
                {{ (mode === 'add' ? 'ADD_NEW_CARD' : 'EDIT_TRAVEL_CARD_SIDE_TITLE') | translate }}
            </h1>
        </div>
    </div>
    <main class="lg:col-start-2 lg:col-end-4">
        <div class="bg-white px-4 pt-0 md:px-0">
            <div class="mb-4" *ngIf="isMobileView">
                <mat-divider></mat-divider>
            </div>
            <p class="font-bold">
                {{ (mode === 'add' ? 'ADD_CARD_TO_SEE_TICKETS_AND_BALANCE' : 'CARD_DETAILS_FORM_TITLE') | translate }}:
            </p>
        </div>
        <div class="mt-8 flex flex-col justify-between rounded-lg bg-grey-white_smoke p-4 dark:bg-contrast-black">
            <div class="bg-white p-4 shadow-[0px_0px_4px_-1px_#0000000F,0px_2px_6px_-1px_#0000001A]" main-1>
                <ion-segment
                    class="py-0.5"
                    *ngIf="bankCardPersonalizationEnabled && mode !== 'edit'"
                    [(ngModel)]="cardType"
                    (ngModelChange)="onCardTypeChange($event)"
                    color="dark"
                    mode="ios">
                    <ion-segment-button
                        class="p-2 text-base leading-5"
                        [ngClass]="
                            cardType === CardTypes.TRAVEL_CARD
                                ? 'font-semibold text-black'
                                : 'font-bold text-grey-zambezy'
                        "
                        [value]="CardTypes.TRAVEL_CARD">
                        <ion-label>{{ CardTypes.TRAVEL_CARD | translate }}</ion-label>
                    </ion-segment-button>
                    <ion-segment-button
                        class="p-2 text-base leading-5"
                        [ngClass]="
                            cardType === CardTypes.BANK_CARD
                                ? 'font-semibold text-black'
                                : 'font-bold text-grey-zambezy'
                        "
                        [value]="CardTypes.BANK_CARD">
                        <ion-label>{{ CardTypes.BANK_CARD | translate }}</ion-label>
                    </ion-segment-button>
                </ion-segment>
                <rwidget-add-edit-card-form
                    *ngIf="cardType === CardTypes.TRAVEL_CARD"
                    [mode]="mode"
                    (formChange)="cardForm = $event"></rwidget-add-edit-card-form>
                <gl-bank-cards-add-edit
                    #bankCardsComponentRef
                    *ngIf="cardType === CardTypes.BANK_CARD && mode === 'add'"
                    (addCardButton)="onAddCardButtonChange($event)"></gl-bank-cards-add-edit>
                <rwidget-bank-cards-edit-form
                    *ngIf="cardType === CardTypes.BANK_CARD && mode === 'edit'"
                    (formChange)="cardForm = $event"></rwidget-bank-cards-edit-form>
            </div>

            <!--Bank card terms-->
            <div class="mt-4" *ngIf="_bankCardTerms && cardType === CardTypes.BANK_CARD">
                <span class="checkbox-wcag">
                    <input
                        class="checkbox-wcag__checkbox"
                        [formControl]="bankCardTermsForm.controls.bankCardTerms"
                        type="checkbox"
                        aria-hidden="true"
                        required
                        tabindex="-1"
                        attr.aria-label="{{ 'READ_TERMS' | translate }} {{ 'WITH_TERMS_AND_CONDITIONS' | translate }} {{
                            'ASTERISK' | translate
                        }}" />

                    <span
                        class="checkbox-wcag__checkmark"
                        (click)="toggleBankCardTerms()"
                        (keydown.enter)="toggleBankCardTerms()"
                        (keydown.space)="toggleBankCardTerms()"
                        tabindex="0"
                        attr.aria-checked="{{ _bankCardTermsAgreed }}"
                        role="checkbox"
                        required
                        attr.aria-label="{{ 'READ_TERMS' | translate }} {{ 'WITH_TERMS_AND_CONDITIONS' | translate }} {{
                            'ASTERISK' | translate
                        }}">
                    </span>

                    <label class="checkbox-wcag__label">
                        <span class="text-left text-base font-medium">
                            <span
                                class="link-label"
                                (click)="toggleBankCardTerms()"
                                (keydown.enter)="toggleBankCardTerms()"
                                (keydown.space)="toggleBankCardTerms()">
                                {{ 'READ_TERMS' | translate }}
                            </span>

                            <a
                                class="pn-app-light:text-primary pn-light:text-primary text-secondary"
                                #modalTrigger
                                (click)="openBankCardTermsModal()"
                                (keydown.enter)="openBankCardTermsModal()"
                                (keydown.space)="openBankCardTermsModal()"
                                tabindex="0"
                                role="link">
                                {{ 'WITH_TERMS_AND_CONDITIONS' | translate }}.*
                            </a>
                        </span>
                    </label>
                </span>
            </div>
        </div>
        <div class="my-8 box-border flex w-full items-center justify-between gap-8 px-4 md:px-0">
            <div class="flex-1" *ngIf="!isMobileView">
                <ridango-ui-back-button (onBack)="navigateByViewMode()">
                    {{ 'LOCAL_BTN_BACK' | translate }}
                </ridango-ui-back-button>
            </div>

            <ng-container *ngIf="cardType === CardTypes.BANK_CARD && mode === 'add'; else addEditCardButton">
                <ion-button
                    class="flex-1"
                    [disabled]="isBankCardButtonDisabled$ | async"
                    (click)="addBankCard()"
                    size="large">
                    <ion-label
                        class="vl-app-light:text-black tallinn-light:text-white whitespace-normal text-base font-bold normal-case text-white dark:text-contrast-black">
                        {{ 'ADD_NEW_CARD' | translate }}
                        {{
                            addCardButton.amount
                                ? '(' + (addCardButton.amount | moneyFormat) + ') ' + (currency | translate)
                                : ''
                        }}
                    </ion-label>
                    <ion-icon
                        class="vl-app-light:text-black tallinn-light:!text-white tartu-light:!text-white"
                        name="arrow-forward-outline"
                        slot="end"></ion-icon>
                </ion-button>
            </ng-container>
            <ng-template #addEditCardButton>
                <rwidget-add-edit-card-button
                    class="flex-1 pb-4 md:pb-0"
                    [cardForm]="cardForm"
                    [mode]="mode"
                    [isMobileView]="isMobileView"
                    (onSuccess)="navigateByViewMode()"></rwidget-add-edit-card-button>
            </ng-template>
        </div>
    </main>
</section>
